var __TEMP__ = require('./_baseIsArrayBuffer.js');var baseIsArrayBuffer = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseUnary.js');var baseUnary = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_nodeUtil.js');var nodeUtil = __REQUIRE_DEFAULT__(__TEMP__);

/* Node.js helper references. */
var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer;

/**
 * Checks if `value` is classified as an `ArrayBuffer` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 * @example
 *
 * _.isArrayBuffer(new ArrayBuffer(2));
 * // => true
 *
 * _.isArrayBuffer(new Array(2));
 * // => false
 */
var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = isArrayBuffer;
